// extracted by mini-css-extract-plugin
export default {"col":"links-col_col__HRBbg","header":"links-col_header__YZorT","body":"links-col_body__79xq6","links":"links-col_links__dk460","social":"links-col_social__pgHmh"};